module.exports = __webpack_public_path__ + "8a5356e9/img/note-edit-icon.acae1669.svg";